





































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import MeterReadingCsvMapping from '@/data/models/meter-reading-csv-mapping';
import Button from '@/components/commons/Button.vue';
import dayjs from "dayjs";

@Component({
  components: {Button},
})
export default class CreateUpdateStructureCSV extends Vue {

  @Prop({required: true})
  meterReading: MeterReadingCsvMapping;

  @Prop({required: true})
  isCreated: boolean;

  @Prop({required: true})
  opened: boolean;

  isFormValid: boolean = true;
  dateFormatItems: { 'text': string, 'value': string }[] = [
    {text: 'DD.MM.YYYY HH:mm', value: 'DD.MM.YYYY HH:mm'},
    {text: 'DD MM YYYY HH:mm', value: 'DD MM YYYY HH:mm'},
    {text: 'DD/MM/YYYY HH:mm', value: 'DD/MM/YYYY HH:mm'},
    { text: 'YYYY-MM-DD HH:mm:00', value: 'YYYY-MM-DD HH:mm:00'},
    {text: 'Autre...', value: ''},
  ];

  exampleDate = [
    {text: 'YY', value: '20'},
    {text: 'YYYY', value: '2020'},
    {text: 'M', value: '1-12'},
    {text: 'MM', value: '01-12'},
    {text: 'D', value: '1-31'},
    {text: 'DD', value: '01-31'},
    {text: 'H', value: '0-23'},
    {text: 'HH', value: '00-23'},
    {text: 'm', value: '0-59'},
    {text: 'mm', value: '00-59'},
    {text: 's', value: '0-59'},
    {text: 'ss', value: '00-59'},
  ];

  get dialog(): boolean {
    return this.opened;
  }

  set dialog(value: boolean) {
    this.$emit('close', value);
  }

  formatExample(format: string): string {
    return dayjs().format(format);
  }

  handleAction(): void {
    this.$store.commit("showLoader", true);
    this.isCreated ? this.createStructure() : this.updateStructure();
  }

  createStructure(): void {
    this.$dao.meters.createCSVStructure(this.meterReading).then(data => {
      if (data != null) {
        this.dialog = false;
      } else {
        throw 'err';
      }
    }).catch(() => {
      this.$dialog.error({text: this.$t('errors.updateMeter').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']});
    }).finally(() => this.$store.commit("showLoader", false));
  }

  updateStructure(): void {
    this.$store.commit("showLoader", true);
    this.$dao.meters.updateCSVStructure(this.meterReading).then(data => {
      if (data != null) {
        this.dialog = false;
      } else {
        throw 'err';
      }
    }).catch(() => {
      this.$dialog.error({text: this.$t('errors.updateMeter').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']});
    }).finally(() => this.$store.commit("showLoader", false));
  }
}
